import { cn, IconButton } from '@kanbu/chatbot-ui';
import { X } from 'lucide-react';
import { memo, type ComponentPropsWithoutRef } from 'react';

export interface FeedbackFrameProps extends ComponentPropsWithoutRef<'div'> {
  title?: string;
  onClose?: () => void;
}

export const FeedbackFrame = memo(function FeedbackFrame({
  title,
  children,
  className,
  onClose,
  ...restProps
}: FeedbackFrameProps) {
  return (
    <div
      className={cn(
        'relative w-full rounded-lg bg-chat-secondary px-3.5 py-3 text-chat-secondary-foreground',
        className,
      )}
      {...restProps}
    >
      {onClose && (
        <IconButton
          type='button'
          variant='outline'
          size='xs'
          circle
          className='absolute right-2 top-2'
          onClick={onClose}
          data-testid='close-feedback-button'
        >
          <X />
        </IconButton>
      )}
      {children}
    </div>
  );
});
